import SinglePortfolio from "../components/layout/portfolio/SinglePortfolio";

const SinglePortfolioPage = (props) => {
  return <SinglePortfolio content1={props.content1} />;
};

export default SinglePortfolioPage;
